import { RangePickerProps } from 'antd/es/date-picker';
import { StyledCalendarEventIcon, StyledXIcon } from 'components/atoms/StyledIcons';
import { GlobalStyle, StyledRangePicker } from './AppRangePicker.styled';

export type AppRangePickerProps = RangePickerProps;

const handleIconEvent = (e: React.MouseEvent | React.TouchEvent) => {
    e.preventDefault();
};

export const AppRangePicker = (props: AppRangePickerProps) => (
    <>
        <GlobalStyle />
        <StyledRangePicker
            suffixIcon={
                <StyledCalendarEventIcon
                    onMouseDown={handleIconEvent}
                    onTouchStart={handleIconEvent}
                    onClick={handleIconEvent}
                    style={{ pointerEvents: 'auto' }}
                />
            }
            allowClear={{ clearIcon: <StyledXIcon /> }}
            {...props}
        />
    </>
);
